import { makeStyles } from '@rbx/ui';

const useSummaryContainerStyles = makeStyles()(() => ({
  descriptionContainer: {
    marginBottom: '24px',
  },
}));

export default useSummaryContainerStyles;
